// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Glyphicon } from 'react-bootstrap';
import { isMobileResolution } from '../../infrastructure/utils/common';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export const ExploreConfigurationElement = ({ actions, value, ind }) => {
  const isMobile = isMobileResolution();

  const deleteCityExplore = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deleteCityExplore(
      event.currentTarget.getAttribute('data-name'),
      'exploreConfigurations'
    );
  };

  const formatStr = arr => {
    if (!arr) {
      return '';
    }

    return arr.length === 1 ? arr[0] : arr.join(', ');
  };

  const updateCityExplore = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.updateCityExplore(
      event.currentTarget.getAttribute('data-name'),
      'exploreConfigurations'
    );
  };

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    <tr key={value.title} data-name={ind} className='listrow moveable'>
      <td style={{ verticalAlign: 'middle' }}>
        <Glyphicon glyph='option-vertical' />
      </td>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      <td style={{ maxWidth: '90px' }} title={value.title}>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <span className='big-text-field'>{value.title}</span>
      </td>
      {!isMobile && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        <td style={{ maxWidth: '60px' }} title={value.subtitle}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span className='big-text-field'>{value.subtitle}</span>
        </td>
      )}
      {!isMobile && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        <td style={{ maxWidth: '90px' }} title={value.tags[0]}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line react/prop-types */}
          <span className='big-text-field'>{formatStr(value.tags)}</span>
        </td>
      )}
      {!isMobile && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        <td style={{ maxWidth: '60px' }} title={value.isRandomized}>
          <span className='big-text-field'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {value.isRandomized ? 'Yes' : 'No'}
          </span>
        </td>
      )}
      {!isMobile && (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        <td style={{ maxWidth: '60px' }} title={value.isGlobal}>
          <span className='big-text-field'>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {value.isGlobal ? 'Yes' : 'No'}
          </span>
        </td>
      )}
      <td
        style={{
          width: '5%',
          textAlign: 'center',
          verticalAlign: 'middle',
          cursor: 'pointer',
          minWidth: '55px',
        }}
      >
        <i
          role='link'
          tabIndex={0}
          className='fas fa-pen'
          data-name={ind}
          onClick={updateCityExplore}
          onKeyPress={updateCityExplore}
          style={{ marginRight: '10px' }}
        />
        <i
          role='link'
          tabIndex={-1}
          className='fas fa-times'
          data-name={ind}
          onClick={deleteCityExplore}
          onKeyPress={updateCityExplore}
        />
      </td>
    </tr>
  );
};
